import classNames from 'classnames/bind';
import styles from './index.module.sass';
import { CoreIcon } from '@autopass-web/mochi-icons';
import iconClose from '../../../../domain/assets/close.svg';
import { forwardRef } from 'react';

const cx = classNames.bind(styles);

interface alertProps {
  type: 'full' | 'float';
  theme?: 'success' | 'warning' | 'notice';
  icon?: any;
  children: any;
  style?: any;
  round?: boolean;
  show: boolean;
  onClose?: () => void;
  className?: any;
}

const Alert = forwardRef(
  (
    {
      type = 'float',
      theme = 'warning',
      icon,
      style,
      children,
      show,
      round,
      onClose,
      className,
    }: alertProps,
    ref: any,
  ) => {
    const alertClass = cx({
      alert: true,
      [type]: true,
      [theme]: true,
      show,
      round,
    });

    return (
      <div className={`${alertClass} ${className}`} style={style} ref={ref}>
        {icon && <CoreIcon className={styles.icon} src={icon} />}
        {children}
        {onClose && (
          <CoreIcon
            className={styles.close}
            src={iconClose}
            onClick={onClose}
          />
        )}
      </div>
    );
  },
);

export default Alert;
